/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

export const SELECT_STATEMENTS_PREFIX = 'SELECT_STATEMENTS_';
export const TIME_PERIOD = 'timePeriod';
export const DOCUMENT_TYPES = 'documentTypes';
export const PRODUCT_TYPES = 'productTypes';

export const REQUESTED_DOCUMENT_REFERENCES = 'REQUESTED_DOCUMENT_REFERENCES';
export const requestedDocumentReferences = () => {
  return {
    type: REQUESTED_DOCUMENT_REFERENCES
  };
};

export const RECEIVED_DOCUMENT_REFERENCES = 'RECEIVED_DOCUMENT_REFERENCES';
export const receivedDocumentReferences = (references) => {
  return {
    type: RECEIVED_DOCUMENT_REFERENCES,
    references
  };
};

export const RECEIVED_CCPA_DOCUMENT_REFERENCES =
  'RECEIVED_CCPA_DOCUMENT_REFERENCES';
export const receivedCCPADocumentReferences = (references) => {
  return {
    type: RECEIVED_CCPA_DOCUMENT_REFERENCES,
    references
  };
};

export const ERROR_DOCUMENT_REFERENCES = 'ERROR_DOCUMENT_REFERENCES';
export const errorDocumentReferences = (error) => {
  return {
    type: ERROR_DOCUMENT_REFERENCES,
    error
  };
};

export const ERROR_CCPA_DOCUMENT_REFERENCES = 'ERROR_CCPA_DOCUMENT_REFERENCES';
export const errorCCPADocumentReferences = (error) => {
  return {
    type: ERROR_CCPA_DOCUMENT_REFERENCES,
    error
  };
};

export const SELECT_STATEMENTS_TIME_PERIOD =
  SELECT_STATEMENTS_PREFIX + 'TIME_PERIOD';
export const selectStatementsTimePeriod = (selection) => ({
  type: SELECT_STATEMENTS_TIME_PERIOD,
  selection
});

export const SELECT_STATEMENTS_DOCUMENT_TYPES =
  SELECT_STATEMENTS_PREFIX + 'DOCUMENT_TYPES';
export const selectStatementsDocumentTypes = (selection) => ({
  type: SELECT_STATEMENTS_DOCUMENT_TYPES,
  selection
});

export const SELECT_STATEMENTS_PRODUCT_TYPES =
  SELECT_STATEMENTS_PREFIX + 'PRODUCT_TYPES';
export const selectStatementsProductTypes = (selection) => ({
  type: SELECT_STATEMENTS_PRODUCT_TYPES,
  selection
});

export const REQUESTED_DOCUMENT_DOWNLOAD = 'REQUESTED_DOCUMENT_DOWNLOAD';
export const requestedDocumentDownload = (documentId) => ({
  type: REQUESTED_DOCUMENT_DOWNLOAD,
  payload: {
    identifier: documentId
  }
});

export const RECEIVED_DOCUMENT_DOWNLOAD = 'RECEIVED_DOCUMENT_DOWNLOAD';
export const receivedDocumentDownload = (documentId) => ({
  type: RECEIVED_DOCUMENT_DOWNLOAD,
  payload: {
    identifier: documentId
  }
});

export const ERROR_DOCUMENT_DOWNLOAD = 'ERROR_DOCUMENT_DOWNLOAD';
export const errorDocumentDownload = (error, documentId) => ({
  type: ERROR_DOCUMENT_DOWNLOAD,
  error,
  payload: {
    identifier: documentId
  }
});
